import { fetchPost } from "@/lib/services";

export async function confirmPaymentService(data: any) {
  return await fetchPost("/create-order/", data);
}

export async function verifyPaymentService(data: any) {
  return await fetchPost("/verify-payment/", data);
}